export { default } from "./CardContactsChange";



// WEBPACK FOOTER //
// ./src/data-containers/CardContactsChange/index.js